import { PartialTranslation } from '../translations';

export const bn: PartialTranslation = {
  newChat: 'নতুন চ্যাট',
  search: 'অনুসন্ধান',
  user: 'ব্যবহারকারী',
  settings: 'সেটিংস',
  language: 'ভাষা',
  getHelp: 'সাহায্য নিন',
  viewAllPlans: 'সব পরিকল্পনা দেখুন',
  learnMore: 'আরও জানুন',
  logOut: 'লগ আউট',
  chooseLanguage: 'ভাষা নির্বাচন করুন',
  chooseYourPreferredLanguage: 'আপনার পছন্দের ভাষা নির্বাচন করুন',
  searchLanguages: 'ভাষা অনুসন্ধান করুন...',
  autoDetect: 'স্বয়ংক্রিয় শনাক্তকরণ',
  noLanguagesFound: 'কোন ভাষা পাওয়া যায়নি',
  askAnything: 'যেকোনো কিছু জিজ্ঞাসা করুন',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'ব্যক্তিগত',
  freePlan: 'বিনামূল্যে পরিকল্পনা',
  current: 'বর্তমান',
  close: 'বন্ধ করুন',
  archive: 'সংরক্ষণাগার',
  delete: 'মুছে ফেলুন',
  confirmDelete: 'আপনি কি এই চ্যাটটি মুছে ফেলতে চান?',
  confirmArchive: 'আপনি কি এই চ্যাটটি সংরক্ষণ করতে চান?',
  deleteCannotUndo: 'এই কাজটি পূর্বাবস্থায় ফেরানো যাবে না।',
  archiveCanFind: 'সংরক্ষণের পর আপনি এটি সংরক্ষণাগার তালিকায় খুঁজে পাবেন।',
  
  // 资源面板
  resources: 'সম্পদ',
  addResource: 'সম্পদ যোগ করুন',
  deleteResource: 'সম্পদ মুছুন',
  noMatchingResourcesFound: 'কোন মিলে যাওয়া সম্পদ পাওয়া যায়নি',
  noResourcesAvailable: 'কোন সম্পদ উপলব্ধ নেই',
  hideResources: 'সম্পদ লুকান',
  showResources: 'সম্পদ দেখান',
  
  // 聊天输入框
  typeMessage: 'একটি বার্তা টাইপ করুন...',
  thinkingOptions: 'চিন্তার বিকল্প',
  deleteFile: 'ফাইল মুছুন',
  clearSelection: 'নির্বাচন সাফ করুন',
  addAttachment: 'সংযুক্তি যোগ করুন',
  sendMessage: 'বার্তা পাঠান',
  
  // 思考模式选项
  deepInsight: 'গভীর অন্তর্দৃষ্টি · পৃষ্ঠ বিশ্লেষণ',
  deepInsightDesc: 'মূল বিষয়গুলির দ্রুত বোঝাপড়া',
  deepExploration: 'গভীর অনুসন্ধান · ব্যাপক বিশ্লেষণ',
  deepExplorationDesc: 'বহুমাত্রিক গভীর গবেষণা',
  deepDeconstruction: 'গভীর বিনির্মাণ · পদ্ধতিগত যুক্তি',
  deepDeconstructionDesc: 'স্তরে স্তরে প্রগতিশীল বিশ্লেষণ',
  
  // 写作模式选项
  contractReview: 'চুক্তি পর্যালোচনা · ঝুঁকি চিহ্নিতকরণ',
  contractReviewDesc: 'ধারা বিশ্লেষণ এবং সম্মতি পরীক্ষা',
  textPolish: 'পাঠ্য পালিশ · পেশাদার অভিব্যক্তি',
  textPolishDesc: 'ভাষা অপ্টিমাইজেশন এবং কাঠামো সমন্বয়',
  legalDocuments: 'আইনি নথি · মানক খসড়া',
  legalDocumentsDesc: 'পেশাদার আইনি নথি লেখা',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'লগ ইন',
  register: 'নিবন্ধন করুন',
  welcomeBack: 'LawHelper-এ স্বাগতম',
  loginSubtitle: 'আপনার AI আইনি গবেষণা সহকারী',
  continueWithGoogle: 'Google দিয়ে চালিয়ে যান',
  continueWithMicrosoft: 'Microsoft দিয়ে চালিয়ে যান',
  continueWithWeChat: 'WeChat দিয়ে চালিয়ে যান',
  orContinueWith: 'অথবা এর সাথে চালিয়ে যান',
  emailTab: 'ইমেইল',
  phoneTab: 'ফোন',
  emailPlaceholder: 'আপনার ইমেইল লিখুন',
  phonePlaceholder: 'ফোন নম্বর লিখুন',
  codePlaceholder: '৬ সংখ্যার কোড লিখুন',
  sending: 'পাঠানো হচ্ছে...',
  verifying: 'যাচাই করা হচ্ছে...',
  verify: 'যাচাই করুন',
  sendMagicLink: 'ম্যাজিক লিঙ্ক পাঠান',
  getVerificationCode: 'কোড পান',
  resendCode: 'কোড পুনরায় পাঠান',
  resendIn: 'পুনরায় পাঠান',
  magicLinkSent: 'ম্যাজিক লিঙ্ক আপনার ইমেইলে পাঠানো হয়েছে',
  magicLinkHint: 'আমরা আপনার ইমেইলে একটি নিরাপদ লিঙ্ক পাঠাব',
  otpSent: 'যাচাইকরণ কোড পাঠানো হয়েছে',
  agreeToTerms: 'চালিয়ে যাওয়ার মাধ্যমে, আপনি সম্মত হচ্ছেন',
  privacyPolicy: 'গোপনীয়তা নীতি',
  termsOfService: 'পরিষেবার শর্তাবলী',
  and: 'এবং',
  privacyTitle: 'আপনার গোপনীয়তা গুরুত্বপূর্ণ',
  privacyIntro: 'আমরা আপনাকে সেরা অভিজ্ঞতা প্রদানের জন্য কুকি এবং অনুরূপ প্রযুক্তি ব্যবহার করি।',
  essentialCookies: 'অপরিহার্য কুকি',
  essentialDesc: 'ওয়েবসাইট কাজ করার জন্য প্রয়োজনীয়',
  analyticsCookies: 'বিশ্লেষণ কুকি',
  analyticsDesc: 'আমাদের সেবা উন্নত করতে সাহায্য করে',
  marketingCookies: 'মার্কেটিং কুকি',
  marketingDesc: 'ব্যক্তিগতকৃত বিষয়বস্তুর জন্য ব্যবহৃত',
  acceptAll: 'সব গ্রহণ করুন',
  essentialOnly: 'শুধুমাত্র অপরিহার্য',
  customize: 'কাস্টমাইজ করুন',
  savePreferences: 'পছন্দ সংরক্ষণ করুন',
  back: 'পিছনে',
  readPrivacyPolicy: 'আমাদের গোপনীয়তা নীতি পড়ুন',
  cookiePolicy: 'কুকি নীতি',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI পর্যালোচনা',
  aiDraft: 'AI খসড়া',
  smartAssistant: 'টেমপ্লেট',

  // 知识库搜索
  enableKnowledgeSearch: 'অনুসন্ধান সক্ষম করুন',
  knowledgeSearchDesc: 'AI আপনার নথিতে অনুসন্ধান করে',
  clickToDisable: 'নিষ্ক্রিয়',
  clickToEnable: 'সক্রিয়',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'রিসোর্স প্যানেল বন্ধ করুন',
  uploading: '%{fileName} আপলোড হচ্ছে...',
  processing: '%{fileName} প্রসেস হচ্ছে...',
  uploadSuccess: '✓ %{fileName} আপলোড হয়েছে',
  uploadError: '✗ আপলোড ব্যর্থ: %{error}',
  quickAnswer: 'দ্রুত উত্তর',
  quickAnswerDesc: 'সহজ প্রশ্নের দ্রুত উত্তর',
  cancelRequest: 'বাতিল',
  library: 'লাইব্রেরি',
  filterAll: 'সব',
  filterChat: 'চ্যাট',
  filterReview: 'পর্যালোচনা',
  filterDraft: 'খসড়া',
  filterTemplate: 'টেমপ্লেট',
  filterForm: 'ফর্ম',
  thinking: 'ভাবছি...',
  thinkingProcess: 'চিন্তা প্রক্রিয়া',
  analyzingLegalLogic: 'আইনি যুক্তি বিশ্লেষণ...',
  lawhelperThinking: 'Lawhelper ভাবছে...',
  serviceError: 'সেবা ত্রুটি',
  uploaded: 'আপলোড হয়েছে',
  settingsGeneral: 'সাধারণ',
  settingsNotifications: 'বিজ্ঞপ্তি',
  settingsAppearance: 'চেহারা',
  settingsProfile: 'প্রোফাইল',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'রঙ মোড',
  settingsLight: 'হালকা',
  settingsDark: 'গাঢ়',
  settingsSystem: 'সিস্টেম',
  about: 'সম্পর্কে',
  reviewTitle: 'নথি পর্যালোচনা',
  exitReview: 'পর্যালোচনা থেকে বের হন',
  uploadPrompt: 'পর্যালোচনার জন্য PDF আপলোড করুন',
  uploadButton: 'ফাইল নির্বাচন',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'পর্যালোচনা হচ্ছে...',
  reviewComplete: 'পর্যালোচনা সম্পন্ন',
  issuesFound: '%{count}টি সমস্যা পাওয়া গেছে',
  draftTitle: 'আইনি নথি প্রণয়ন',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'তৈরি হচ্ছে...',
  generatedSuccess: '✅ নথি তৈরি হয়েছে!',
  drafterWelcome: 'AI নথি সহায়কে স্বাগতম',
  drafterYouCan: 'আপনি করতে পারেন:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'উদাহরণ:',
  drafterExampleRental: '"ভাড়া চুক্তি তৈরি করুন"',
  drafterExampleLabor: '"শ্রম চুক্তি পূরণ করুন"',
  drafterInputPlaceholder: 'আপনার প্রয়োজন বর্ণনা করুন...',
  drafterThinking: 'ভাবছি...',
  drafterHistoryTitle: 'ইতিহাস',
  drafterNoHistory: 'কোনো ইতিহাস নেই',
  drafterNewChat: 'নতুন চ্যাট',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'নথি সংরক্ষণ',
  drafterDownload: 'নথি ডাউনলোড',
  drafterUndo: 'পূর্বাবস্থা',
  drafterRedo: 'পুনরায়',
  drafterBold: 'মোটা',
  drafterItalic: 'তির্যক',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'প্রস্থান',
  drafterConfirm: 'নিশ্চিত',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI কর্মপ্রবাহ',
  workflowRunning: 'চলছে...',
  workflowReady: 'প্রস্তুত',
  workflowCompleted: 'সম্পন্ন',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'পরিবর্তন গ্রহণ',
  rejectChanges: 'পরিবর্তন প্রত্যাখ্যান',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'থামান',
  restartWorkflow: 'Restart',
  startDrafting: 'প্রণয়ন শুরু',
  interrupt: 'Stop',
  documentSubject: 'নথির বিষয় *',
  documentType: 'নথির ধরন',
  jurisdiction: 'বিচার এখতিয়ার',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'চুক্তি',
  docTypeAgreement: 'সম্মতি',
  docTypeNotice: 'Notice',
  docTypeLetter: 'চিঠি',
  docTypePetition: 'Petition',
  docTypeWill: 'উইল',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'চীন',
  countryUSA: 'যুক্তরাষ্ট্র',
  countryGermany: 'জার্মানি',
  countryJapan: 'জাপান',
  countryFrance: 'ফ্রান্স',
  countryUK: 'যুক্তরাজ্য',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'স্মার্ট নথি সহায়ক',
  smartDocChatTitle: 'AI নথি সহায়ক',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'ফাইল নির্বাচন',
  smartDocOr: 'অথবা',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'ত্রুটি',
  unknownError: 'অজানা ত্রুটি',
  file: 'ফাইল',
  loading: 'লোড হচ্ছে...',
  localFolders: 'স্থানীয় ফোল্ডার',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'সংরক্ষণ',
  renameFile: 'নাম পরিবর্তন',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI বিশ্লেষণ',
};
